import { capitalize } from "lodash-es";

import { t } from "i18n/i18n";
import { CircleCheckFilledIcon, CircleExclamationIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectLmsSectionId, selectLmsType } from "store/selectors";

export const LMSConnectionIndicator = () => {
  const lmsType = useAppSelector(selectLmsType);
  const lmsSectionId = useAppSelector(selectLmsSectionId);

  return (
    <div className="flex items-center gap-1">
      {lmsSectionId ? (
        <>
          <CircleCheckFilledIcon className="text-green" />
          <span className="body-s">
            {lmsType
              ? t("settings.connected_to_lms", { lms: capitalize(lmsType) })
              : t("settings.connected_to_unknown_lms")}
          </span>
        </>
      ) : (
        <>
          <CircleExclamationIcon className="text-orange" size="m" />
          <span className="body-s">{t("settings.not_connected_to_lms")}</span>
        </>
      )}
    </div>
  );
};
